module.exports = __webpack_public_path__ + "static/media/smart-farm.f88871fa.svg";